import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadSound } from "./PostVideo";

// The sound of a post that has no video: a "♪ title · artist" link to the sound's page and a small player.
// (A post with a video shows the sound under the video instead, see PostVideo.) Renders nothing when the sound cannot be loaded.
export default function PostSound({ soundId, silenced = false }) {
  const [sound, setSound] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setSound(null);
    if (!soundId || silenced) return undefined; // silenced: the rights team muted this post, so its sound is not offered
    loadSound(soundId).then((s) => { if (!cancelled && s?.audio_url) setSound(s); }).catch(() => { /* leave the post as it is */ });
    return () => { cancelled = true; };
  }, [soundId, silenced]);

  if (!sound) return null;
  const artist = sound.artists?.length ? sound.artists.map((a) => a.name).join(", ") : sound.artist_name;

  return (
    <div className="mt-3" data-testid="post-sound" onClick={(e) => e.stopPropagation()}>
      <Link to={`/sound/${sound.id}`} state={{ from: "post" }} className="block min-w-0 truncate text-sm font-semibold text-gray-800 hover:underline">
        ♪ {sound.title}{artist ? ` · ${artist}` : ""}
      </Link>
      <audio src={sound.audio_url} controls preload="none" className="mt-2 w-full max-w-md" />
    </div>
  );
}
